import { useMutation } from '@tanstack/react-query';
import { useToast } from '@chakra-ui/react';
import { EmailType } from '@acp/shared';
import { downloadEmail } from '../service';

function useDownloadMutation(
    metaData: {
        emailType: EmailType;
        noticeId?: number;
        quoteId?: number;
        invoiceId?: number;
        propertyId?: number;
    },
    opts?: { onSuccess?: () => void; onError?: (error: Error) => void }
) {
    const toast = useToast();

    const downloadEmailMutation = useMutation({
        mutationFn: async ({
            message, //
            toAddresses,
            ccAddresses,
        }: {
            message: string | null;
            toAddresses?: string[];
            ccAddresses?: string[];
        }) => downloadEmail(metaData.emailType, {
            ...metaData,
            message,
            toAddresses,
            ccAddresses,
        }),
        onSuccess: (fileUrl) => {
            if (fileUrl != null) {
                const link = document.createElement('a');
                link.href = fileUrl;
                link.target = '_blank';
                link.download = `${metaData.emailType}.eml`;

                document.body.appendChild(link);

                link.click();

                document.body.removeChild(link);
                URL.revokeObjectURL(fileUrl);

                toast({
                    title: 'Download Success',
                    description: 'Please check your downloads folder for the Email File',
                    status: 'success',
                    isClosable: true,
                });

                if (opts?.onSuccess != null) opts.onSuccess();
            }
        },
        onError: (error) => {
            // eslint-disable-next-line @typescript-eslint/no-use-before-define

            toast({
                title: 'Request Failed',
                description: error.message,
                status: 'error',
                isClosable: true,
            });

            if (opts?.onError != null) opts.onError(error);
        },
    });

    return downloadEmailMutation;
}

export { useDownloadMutation };
